import { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Target, ArrowLeft, LogOut, Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import useAuthStore from '@/stores/authStore';

export default function ScorerLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, logout, isAdmin } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleBack = () => {
    if (isAdmin()) navigate('/admin');
    else if (window.history.length > 1) navigate(-1);
    else navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#06080d]" data-testid="scorer-layout">
      {/* Header */}
      <header className="sticky top-0 z-30 flex items-center justify-between h-14 px-4 lg:px-6 border-b border-[#252a37] bg-[#06080d]/85 backdrop-blur">
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            onClick={handleBack}
            className="text-[#8a93a3] hover:text-[#f0f2f7] flex items-center gap-1.5 px-2"
            data-testid="scorer-back-to-admin"
          >
            <ArrowLeft className="h-4 w-4" />
            <span className="text-sm hidden sm:inline">{isAdmin() ? 'Admin' : 'Back'}</span>
          </Button>
          <div className="flex items-center gap-2">
            <Target className="h-5 w-5 text-[#f5c518]" />
            <span className="font-semibold text-[#f0f2f7]">Scorer Portal</span>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <img src="/circles-logo.png" alt="Circles" className="h-8 w-8 rounded-full object-cover flex-shrink-0"
            onError={e => { e.currentTarget.style.display='none'; }}/>
          <img src="/c7-logo.png" alt="C7" className="h-8 w-8 rounded-full object-cover flex-shrink-0"
            onError={e => { e.currentTarget.style.display='none'; }}/>
          <span className="text-sm text-[#8a93a3] hidden sm:inline">
            {user?.display_name}
          </span>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleLogout}
            className="text-[#8a93a3] hover:text-[#f0f2f7]"
            data-testid="scorer-logout-button"
          >
            <LogOut className="h-5 w-5" />
          </Button>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="py-4 px-6 text-center text-xs text-[#8a93a3] border-t border-[#252a37]">
        © Sandeep Maheshwari
      </footer>
    </div>
  );
}
